module.exports = __webpack_public_path__ + "img/free.96235dc0.png";